import { store } from "@store/store";
import { setToastData } from "@store/slices/globalState";
import Router from "next/router";
import { updateLoader } from "@store/slices/config";

const updateDashcamAddressApi = async (data: any) => {
  const url = `${process.env.SDUI_API_SERVICE}/update-dashcam-address`;
  const { order_id } = Router.query;
  const { globalState } = store?.getState() || {};
  const requestPayload = globalState?.requestPayload;
  const customData = requestPayload?.data || {};
  const bodyData = {
    order_id: order_id,
    ...data,
    ...customData
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bodyData)
    });

    if (!response.ok) {
      throw new Error(`Error in updateDashcamAddress API`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("updateDashcamAddress Error:", error);
    throw error;
  }
};

export const updateDashcamAddress = async (payloadData?:any) => {
  store?.dispatch(updateLoader(true));
  
  try {
    const response = await updateDashcamAddressApi(payloadData);
    store?.dispatch(updateLoader(false));
    return response;
  } catch (error: any) {
    store?.dispatch(updateLoader(false));
    store?.dispatch(
      setToastData({
        toastMessage: "Something went wrong",
        toastMessageType: "error"
      })
    );
    throw error;
  }
};

